import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import { addReminder, getAllRemindersList, updateReminder } from '../../Services/Reminder/action';
import { connect } from 'react-redux';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import { toast } from 'react-toastify';


const ReminderAddEdit = (props) => {

  const navigate = useNavigate();
  const location = useLocation();
  const data = location?.state?.data?.allData;

  const [Fields, setFields] = useState({
    start_date: data?.date || null,
    description: data?.description || '',
    no_of_days: data?.no_of_days || "",
  });

  const handleSave = async () => {
    try {
      if (!Fields.start_date || !Fields.description) {
        toast.error("Please fill all required fields");
        return;
      }
      const payload = {
        start_date: Fields.start_date,
        description: Fields.description,
        user_id: props?.user?.id,
      };

      if (data) {
        await props?.updateReminder(data?.id, payload);
      } else {
        await props?.addReminder(payload);
      }

      await props.getAllRemindersList(props?.user?.id);

      navigate(-1);
    } catch (error) {
      console.error("Error saving reminder:", error);
    }
  };

  return (
    <div className='ticket-container mb-5'>
      <div className="page-title">
        <h4>{location.pathname === "/reminder/add" ? "Add" : "Update"} Reminder</h4>
        <div className='edit-btn'>
          <button
            type="submit"
            className="custom-btn"
            onClick={() => navigate(-1)}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="custom-btn"
            onClick={handleSave}
          >
            Save
          </button>
        </div>
      </div>
      <div className='row parent-filter m-0 pt-4 pb-5 h-auto mb-4'>
        <div className="col-lg-6 mb-4">
          <div className="input-group">
            <label className="label w-100">Select Date <span style={{ color: 'red' }}>*</span></label>
            <DatePicker
              selected={Fields.start_date ? new Date(Fields.start_date) : null}
              onChange={(date) => {
                const formatted = moment(date).format('YYYY-MM-DD');
                setFields({ ...Fields, start_date: formatted });
              }}
              dateFormat="dd-MM-yyyy"
              placeholderText="Select start date"
              className="input-css"
            />
          </div>
        </div>

        <div className="col-lg-6 mb-4">
          <label className='form-label'>Reminder Title <span style={{ color: 'red' }}>*</span></label>
          <input
            type="text"
            className="input-css"
            placeholder="Enter reminder title"
            value={Fields.description}
            onChange={(e) => setFields({ ...Fields, description: e.target.value })}
          />
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    loading: state.reminderReducer?.loading || false,
    reminder: state.reminderReducer?.reminder || [],
    user: state.authenticationReducer.user,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    addReminder: (data, callback) => {
      dispatch(addReminder(data, callback))
    },
    updateReminder: (id, data) => {
      dispatch(updateReminder(id, data))
    },
    getAllRemindersList: (id) => {
      dispatch(getAllRemindersList(id))
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ReminderAddEdit);